<template>
  <div class="c-waf">
    <v-row no-gutters>
      <v-col cols="4" v-for="item in items" :key="item.title">
        <div class="c-waf__elt" >
          <div class="c-waf__title">{{ item.title }}:</div>
          <div class="c-waf__box">
            <div class="c-waf__text">
              <div class="c-waf-primary">{{ item.primaryText }}</div>
              <div class="c-waf-secondary">{{ item.secondaryText }}</div>
            </div>
            <div :class="'c-waf__banner c-waf__banner-' + item.color" v-if="item.color"></div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { STATS_GET_WAF } from '@/store/actions/stats';
import PeriodListener from '@/mixins/PeriodListener';


export default {
  name: 'WallOfFame',

  mixins: [
    PeriodListener
  ],

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState({
      items: state => {
        const wallOfFame = state.stats.wallOfFame;

        const res = [];
        if (wallOfFame.wine) {
          res.push({
            title: 'Le meilleur vin',
            color: wallOfFame.wine.color,
            primaryText: wallOfFame.wine.name,
            secondaryText: wallOfFame.wine.producer_name
          });
        }
        if (wallOfFame.client) {
          res.push({
            title: 'Le meilleur client',
            primaryText: wallOfFame.client.name,
            secondaryText: wallOfFame.client.group_name
          });
        }
        if (wallOfFame.city) {
          res.push({
            title: 'La meilleure ville',
            primaryText: wallOfFame.city.city
          });
        }

        return res;
      }
    })
  },

  mounted () {
    this.fetchData();
  },

  methods: {
    fetchData () {
      this.loading = true;

      this.$store.dispatch(STATS_GET_WAF)
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.c-waf {
  display: block;
  text-align: center;

  &__elt {
    display: inline-block;
    margin: 0 20px 0 20px;
  }

  &__title {
    margin-bottom: 10px;
  }

  &__box {
    position: relative;
    background-color: lightgray;
    color: black;
    border-radius: 2px;
    width: 150px;
    height: 120px;
  }

  &__text {
    padding: 20px;
  }

  &-primary {
    text-transform: capitalize;
  }

  &-secondary {
    font-size: 12px;
    text-transform: capitalize;
  }

  &__banner {
    position: absolute;
    bottom: 15px;
    width: 100%;
    height: 8px;
    background-color: grey;

    &-red {
      background-color: $wine-red;
    }

    &-rose {
      background-color: $wine-rose;
    }

    &-white {
      background-color: $wine-white;
    }
  }
}

</style>
